import {
  HouseIcon,
  PackageCheckIcon,
  MessageSquareQuoteIcon,
  ListChecksIcon,
  CircleUserRoundIcon,
} from "lucide-react";
import { Hero } from "./hero";
import { Features } from "./api-and-pricing";
import { Points } from "./points";
import { FfrVideo } from "./ffrVideo";

import type { LandingSectionData } from "./landingPageSection";
import { AboutSection } from "./about";
import { Testimonials } from "./testimonials";

// Rendered in order, top to bottom.
//
// If mobileNavTab object is present, will render into the mobile tab bar.
// NOTE: Test appearance in both desktop nav and mobile nav if making changes.
export const sections: LandingSectionData[] = [
  {
    id: "hero",
    content: <Hero />,
    mobileNavTab: { label: "Home", icon: <HouseIcon /> },
  },
  { id: "ffrVideo", content: <FfrVideo /> },
  {
    id: "about",
    content: <AboutSection />,
    mobileNavTab: { label: "About", icon: <CircleUserRoundIcon /> },
  },
  {
    id: "testimonials",
    content: <Testimonials />,
    mobileNavTab: { label: "Testimonials", icon: <MessageSquareQuoteIcon /> },
  },
  {
    id: "points",
    content: <Points />,
    mobileNavTab: { label: "Points", icon: <ListChecksIcon /> },
  },
  {
    id: "api-and-pricing",
    content: <Features />,
    mobileNavTab: { label: "API & Pricing", icon: <PackageCheckIcon /> },
  },
] as const;

export { LandingPageSection } from "./landingPageSection";
